<aside class="side-menu" [class.collapsed]="sidebar.collapsed">
    <nav class="menu-list">
        @for (item of baseMenuList; track item.label) {
            <div class="menu-item-wrapper">
                <div
                    class="menu-item"
                    [class.is-active]="isItemActive(item)"
                    [class.is-parent-active]="isParentActive(item)"
                    [class.is-expanded]="isExpanded(item)"
                    [attr.title]="sidebar.collapsed && !item.children?.length ? (item.label | translate) : null"
                    (click)="onParentClick(item, $event)"
                    (mouseenter)="openFlyout(item, $event)"
                    (mouseleave)="scheduleCloseFlyout()"
                >
                    <img class="menu-icon" [src]="item.icon" alt="" />
                    <span class="menu-label">{{ item.label | translate }}</span>
                    @if (item.children?.length) {
                        <img
                            class="menu-arrow"
                            [src]="
                                isExpanded(item)
                                    ? 'assets/images/menuUp.svg'
                                    : 'assets/images/menuDown.svg'
                            "
                            alt=""
                        />
                    }
                </div>
                @if (item.children?.length && isExpanded(item)) {
                    <div class="submenu-list">
                        @for (child of item.children; track child.label) {
                            <a
                                class="submenu-item"
                                [class.is-active]="isChildActive(child)"
                                [routerLink]="child.path"
                            >
                                {{ child.label | translate }}
                            </a>
                        }
                    </div>
                }
            </div>
        }
    </nav>

    <div class="side-menu-footer">
        <lokos-need-help-card></lokos-need-help-card>
    </div>
</aside>

@if (sidebar.collapsed && flyoutItem) {
    <div
        class="submenu-flyout"
        [style.top.px]="flyoutTop"
        (mouseenter)="keepFlyout()"
        (mouseleave)="scheduleCloseFlyout()"
    >
        @for (child of flyoutItem.children; track child.label) {
            <a
                class="flyout-item"
                [class.is-active]="isChildActive(child)"
                [routerLink]="child.path"
                (click)="closeFlyout()"
            >
                {{ child.label | translate }}
            </a>
        }
    </div>
}
